import { render } from "./process-design.html?vue&type=template&id=4c876816&scoped=true&ts=true"
import script from "./process-design.ts?vue&type=script&lang=ts"
export * from "./process-design.ts?vue&type=script&lang=ts"

import "./process-design.scss?vue&type=style&index=0&id=4c876816&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c876816"]])

export default __exports__